import { FC } from 'react';
import Link from 'next/link';

import Heading from '@/components/common/Heading';

import { FooterType } from '@/types';

interface IFooterCompanyProps {
  footerCompany: FooterType[];
}

const FooterCompany: FC<IFooterCompanyProps> = ({ footerCompany }) => {
  return (
    <div className="md:w-[25%]">
      <Heading headingLevel="h3" className="mb-4 md:mb-8 text-xl">
        Company
      </Heading>
      <ul className="mr-6">
        {footerCompany.map(({ id, title, path, ariaLabel }: FooterType) => (
          <li key={id}>
            <Link
              href={`${path}`}
              className="custom-p text-[0.9rem] leading-8 py-2 hover:text-[--accent-color]"
              aria-label={ariaLabel}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterCompany;
